import qRequest from '@/utils/request';

const modulesFiles = require.context('./modules', true, /\.js$/);

/**
 * api配置说明，暂支持两级配置，模块：操作
 * 第一级为模块名(就是文件名)
 * 第二级为模块下的操作方法名，type：请求方式
 * 业务模块使用方式：this.$q.模块名.方法名
 * 参数加在URL？后，请求时传递参数{params: {xxxx}}   ==>  url?param=xxx
 * 参数加在URL？前，请求时传递参数{fragment: [x1, x2]} ==>  url/x1/x2
 * 参数在请求体中，请求时传递参数{data: {xxxx}}
 */
const api = modulesFiles.keys().reduce((modules, modulePath) => {
  // 文件名作为模块名
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1');
  const value = modulesFiles(modulePath);
  modules[moduleName] = value.default;
  return modules;
}, {});

console.log('api', api);

Object.keys(api).forEach(moduleName => {
  qRequest.parseRouter(moduleName, api[moduleName]);
});

export default qRequest;